var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{},[_c('div',{staticClass:"announcement"},[_c('img',{attrs:{"src":"http://cdn2024.shiwuzone.com/routuan/image/zidingyi-gonggao.png","alt":""}}),_c('div',{staticClass:"announcement-font ellipsis"},[_vm._v(_vm._s(_vm.msg.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }